<template>
  <v-container fluid>
    <p>
      <v-btn href="https://intern.gymkirchenfeld.ch/timetable" target="_blank"
        ><v-icon>mdi-open-in-new</v-icon> Stundenpläne auf intern
      </v-btn>
    </p>
    <v-card>
      <v-system-bar>Stundenplan veröffentlichen</v-system-bar>
      <v-card-text>
        Das Einschalten hat folgende Auswirkungen:
        <ul>
          <li>
            Der Stundenplan für das nächste Semester wird auf Intern und auf der
            öffentlichen Website angezeigt.
          </li>
          <li>
            Bei der nächsten Durchführung der Automatisieung «Klassenbücher»
            werden die Klassenbücher für das nächste Semester erstellt.
          </li>
        </ul>
        <v-switch
          inset
          hide-details
          v-model="nextTermPublished"
          :label="nextTermLabel"
        ></v-switch
      ></v-card-text>
    </v-card>
    <v-card class="mt-4">
      <v-system-bar>Stundenplan importieren</v-system-bar>
      <v-card-text v-if="importStatus.importRunning">
        Der Stundenplan wird importiert: {{ importStatus.importProgress }} von
        {{ importStatus.importCount }} Anlässen verarbeitet.
        <v-progress-linear
          :value="
            (importStatus.importProgress / importStatus.importCount) * 100
          "
          class="mt-2"
        ></v-progress-linear>
      </v-card-text>
      <v-card-text v-else>
        <p>
          Diese aktuell importierten Stundenpläne werden jeden Abend um 23 Uhr
          mit Evento synchronisiert:
        </p>
        <ul
          v-for="timetable in importStatus.timetables"
          v-bind:key="timetable.term.id"
        >
          <li>
            {{ timetable.term.fullText }}: Version
            {{ timetable.version }} importiert am
            <DateValue :value="timetable.importDate" /> um
            <TimeValue :value="timetable.importTime" /> Uhr.
          </li>
        </ul>

        <p>
          Wähle die Untis-Datei zum Hochladen aus und setze das passende
          Semester:
        </p>
        <v-row>
          <v-col cols="12" md="6">
            <form ref="untisUploadForm">
              <v-file-input
                name="file"
                v-model="uploadFile"
                label="Untis-Datei"
              ></v-file-input>
            </form>
          </v-col>
          <v-col cols="12" md="6">
            <TermInput v-model="term" :range="[0, 1]" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer /><v-btn
          outlined
          color="primary"
          @click="upload"
          :disabled="!canUpload"
          text
          >importieren</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import TermInput from "@/components/TermInput.vue";
import DateValue from "common/components/DateValue.vue";
import TimeValue from "common/components/TimeValue.vue";
export default defineComponent({
  name: "Timetable",
  components: { TermInput, DateValue, TimeValue },
  data() {
    return {
      importStatus: {},
      term: null,
      uploadFile: {
        name: "",
      },
      nextTermPublished: false,
      timeout: null,
    };
  },
  computed: {
    canUpload() {
      return this.term && this.uploadFile.name;
    },
    nextTermLabel() {
      return this.nextTermPublished
        ? "nächstes Semester veröffentlicht"
        : "nächstes Semester noch nicht veröffentlicht";
    },
  },
  watch: {
    async nextTermPublished() {
      await this.apiPost({
        resource: "course/timetable",
        data: { nextTermPublished: this.nextTermPublished },
      });
    },
  },
  async created() {
    const result = await this.apiList({ resource: "course/timetable" });
    this.nextTermPublished = result.nextTermPublished;
    this.update();
  },
  beforeRouteLeave(to, from, next) {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    next();
  },
  methods: {
    async upload() {
      var formElement = this.$refs.untisUploadForm;
      await this.apiUploadPost({
        resource: `automation/timetable?term=${this.term.id}`,
        form: formElement,
      });
      await this.update();
    },
    async update() {
      this.importStatus = await this.apiList({
        resource: "automation/timetable",
      });
      if (this.importStatus.importRunning) {
        this.timeout = setTimeout(this.update, 1000);
      }
    },
  },
});
</script>
